import React from 'react'
import Wrapper from './style'

const index = ({href, children}) => {
	return (
		<Wrapper>
			<a href={href}>
				{children}
			</a>
		</Wrapper>
	)
}

export default index